import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import theme from 'theme/theme';
import utils from 'helpers/utils';
import { ActivateIcon, FalseIcon, NullIcon } from 'assets/materialIcons/materialIcons';

const StyledListContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const StyledList = styled.div`
    display: block;
    width: 50%;
`;

const StyledResult = styled.div`
    display: flex;
    height: 35px;
    width: ${ (props) => {
 return props.isSubMenu ? '100%' : '50%';
} };
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    cursor: ${ (props) => {
 return props.isButton ? 'pointer' : 'default';
} };
`;

const StyledResultValue = styled.div`
    display: flex;
    align-items: center;
    margin-left: ${ (props) => {
 return props.isSubMenu ? '15px' : '0';
} };
`;

class ValidationResult extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showBody: false,
        };
    }

    toggleBody = (isItemsValid) => {
        const { showBody } = this.state;

        if (!isItemsValid) {
            this.setState({ showBody: !showBody });
        }
    }

    render() {
        const { name, translate, value } = this.props;
        const { showBody } = this.state;

        const validateValue = (value, key) => {
            if (typeof value === 'boolean') {
                switch (value) {
                    case true:
                        return <ActivateIcon color={ theme.actions.true } />;
                    case false:
                        return <FalseIcon color={ theme.actions.false } />;
                    default:
                        return <NullIcon color={ theme.actions.neutral } />;
                }
            }

            if (utils.has(value, 'price') && utils.has(value, 'currency')) {
                return <span>{ utils.formatPrice(value.price, value.currency) }</span>;
            }

            if (typeof value === 'number' && key.includes('price')) {
                return <span>{ utils.formatPrice(value) }</span>;
            }

            if (typeof value === 'number' && !key.includes('price')) {
                return <span>{ value }</span>;
            }

            if (typeof value === 'string') {
                return <span>{ value }</span>;
            }

            return null;
        };

        if (name === 'configuration' && utils.isObject(value)) {
            const isItemsValid = Object.values(value).every((item) => {
                return item;
            });
            const item = { ...value };

            return (
                <StyledListContainer>
                    <StyledResult isButton={ !isItemsValid } onClick={ () => {
                        return this.toggleBody(isItemsValid);
                    } }>
                        <StyledResultValue>{ translate(`resources.products.availability.results.${ name }`) }</StyledResultValue>
                        <StyledResultValue>{ validateValue(isItemsValid, name) }</StyledResultValue>
                    </StyledResult>

                    {
                        showBody &&
                            <StyledList>
                                { utils.map(item, function (itemValue, itemName) {
                                    return (
                                        <StyledResult key={ itemName } isSubMenu={ true }>
                                            <StyledResultValue isSubMenu={ true }>{ translate(`resources.products.availability.results.${ itemName }`) }</StyledResultValue>
                                            <StyledResultValue>{ validateValue(itemValue, itemName) }</StyledResultValue>
                                        </StyledResult>
                                    );
                                })
                                }
                            </StyledList>
                    }
                </StyledListContainer>
            );
        }

        return (
            <StyledResult>
                <StyledResultValue>{ translate(`resources.products.availability.results.${ name }`) }</StyledResultValue>
                <StyledResultValue>{ validateValue(value, name) }</StyledResultValue>
            </StyledResult>
        );
    }
}

ValidationResult.propTypes = {
    name: PropTypes.string,
    translate: PropTypes.func,
    value: PropTypes.any,
};

export default ValidationResult;


// WEBPACK FOOTER //
// ./src/pages/products/productAvailibity/ValidationResult.js